import { SVGFC } from '@repo/toolkit/types'

const BuildingIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.1108 8.32031L16.0052 9.29989C16.3997 9.38385 16.6664 9.7197 16.6664 10.1171V15.8266C16.6664 16.2912 16.2941 16.6663 15.833 16.6663H10.833C10.9886 16.6663 11.1108 16.5431 11.1108 16.3864V16.1065H15.833C15.983 16.1065 16.1108 15.9834 16.1108 15.8266V10.1171C16.1108 9.98839 16.0219 9.87084 15.8941 9.84285L11.1108 8.89126V8.32031Z"
        fill={color}
      />
      <path
        d="M14.1672 11.0684C14.3228 11.0684 14.445 11.1915 14.445 11.3482C14.445 11.505 14.3228 11.6281 14.1672 11.6281H13.0561C12.9005 11.6281 12.7783 11.505 12.7783 11.3482C12.7783 11.1915 12.9005 11.0684 13.0561 11.0684H14.1672Z"
        fill={color}
      />
      <path
        d="M14.1672 12.748C14.3228 12.748 14.445 12.8712 14.445 13.0279C14.445 13.1847 14.3228 13.3078 14.1672 13.3078H13.0561C12.9005 13.3078 12.7783 13.1847 12.7783 13.0279C12.7783 12.8712 12.9005 12.748 13.0561 12.748H14.1672Z"
        fill={color}
      />
      <path
        d="M14.1672 14.4277C14.3228 14.4277 14.445 14.5509 14.445 14.7076C14.445 14.8643 14.3228 14.9875 14.1672 14.9875H13.0561C12.9005 14.9875 12.7783 14.8643 12.7783 14.7076C12.7783 14.5509 12.9005 14.4277 13.0561 14.4277H14.1672Z"
        fill={color}
      />
      <path
        d="M11.1093 16.3859C11.1093 16.5426 10.987 16.6658 10.8315 16.6658C10.6759 16.6658 10.5537 16.5426 10.5537 16.3859V16.106V8.54932C10.5537 8.46536 10.5926 8.387 10.6537 8.33102C10.7204 8.28064 10.8037 8.25825 10.887 8.27504L11.1093 8.31982V8.89078V16.106V16.3859Z"
        fill={color}
      />
      <path
        d="M10.5558 16.1074V16.3873C10.5558 16.544 10.678 16.6672 10.8336 16.6672H8.61133C8.76688 16.6672 8.88911 16.544 8.88911 16.3873V16.1074H10.5558Z"
        fill={color}
      />
      <path
        d="M9.16721 6.03125C9.32277 6.03125 9.44499 6.1544 9.44499 6.31113C9.44499 6.46786 9.32277 6.59101 9.16721 6.59101H8.0561C7.90054 6.59101 7.77832 6.46786 7.77832 6.31113C7.77832 6.1544 7.90054 6.03125 8.0561 6.03125H9.16721Z"
        fill={color}
      />
      <path
        d="M9.44499 7.99082C9.44499 8.14755 9.32277 8.27069 9.16721 8.27069H8.0561C7.90054 8.27069 7.77832 8.14755 7.77832 7.99082C7.77832 7.83408 7.90054 7.71094 8.0561 7.71094H9.16721C9.32277 7.71094 9.44499 7.83408 9.44499 7.99082Z"
        fill={color}
      />
      <path
        d="M9.16721 9.39062C9.32277 9.39062 9.44499 9.51377 9.44499 9.6705C9.44499 9.82723 9.32277 9.95038 9.16721 9.95038H8.0561C7.90054 9.95038 7.77832 9.82723 7.77832 9.6705C7.77832 9.51377 7.90054 9.39062 8.0561 9.39062H9.16721Z"
        fill={color}
      />
      <path
        d="M9.16721 11.0684C9.32277 11.0684 9.44499 11.1915 9.44499 11.3482C9.44499 11.505 9.32277 11.6281 9.16721 11.6281H8.0561C7.90054 11.6281 7.77832 11.505 7.77832 11.3482C7.77832 11.1915 7.90054 11.0684 8.0561 11.0684H9.16721Z"
        fill={color}
      />
      <path
        d="M6.66667 11.3482C6.66667 11.505 6.54445 11.6281 6.38889 11.6281H5.27778C5.12222 11.6281 5 11.505 5 11.3482C5 11.1915 5.12222 11.0684 5.27778 11.0684H6.38889C6.54445 11.0684 6.66667 11.1915 6.66667 11.3482Z"
        fill={color}
      />
      <path
        d="M6.38889 6.03125C6.54445 6.03125 6.66667 6.1544 6.66667 6.31113C6.66667 6.46786 6.54445 6.59101 6.38889 6.59101H5.27778C5.12222 6.59101 5 6.46786 5 6.31113C5 6.1544 5.12222 6.03125 5.27778 6.03125H6.38889Z"
        fill={color}
      />
      <path
        d="M6.38889 7.71094C6.54445 7.71094 6.66667 7.83408 6.66667 7.99082C6.66667 8.14755 6.54445 8.27069 6.38889 8.27069H5.27778C5.12222 8.27069 5 8.14755 5 7.99082C5 7.83408 5.12222 7.71094 5.27778 7.71094H6.38889Z"
        fill={color}
      />
      <path
        d="M6.38889 9.39062C6.54445 9.39062 6.66667 9.51377 6.66667 9.6705C6.66667 9.82723 6.54445 9.95038 6.38889 9.95038H5.27778C5.12222 9.95038 5 9.82723 5 9.6705C5 9.51377 5.12222 9.39062 5.27778 9.39062H6.38889Z"
        fill={color}
      />
      <path
        d="M8.3315 13.5877C8.3315 13.4309 8.20372 13.3078 8.05372 13.3078H6.38705C6.23149 13.3078 6.10927 13.4309 6.10927 13.5877V16.1066H5.55371V13.5877C5.55371 13.1231 5.92593 12.748 6.38705 12.748H8.05372C8.51483 12.748 8.88705 13.1231 8.88705 13.5877V16.1066H8.3315V13.5877Z"
        fill={color}
      />
      <path
        d="M6.10927 16.1074H8.3315H8.88705V16.3873C8.88705 16.544 8.76483 16.6672 8.60927 16.6672H5.83149C5.67593 16.6672 5.55371 16.544 5.55371 16.3873V16.1074H6.10927Z"
        fill={color}
      />
      <path
        d="M4.30523 3.34488L10.4108 4.27968C10.8164 4.34685 11.1108 4.69389 11.1108 5.10811V8.32112L10.8886 8.27633C10.8052 8.25954 10.7219 8.28193 10.6552 8.33231C10.5941 8.38829 10.5552 8.46665 10.5552 8.55061V5.10811C10.5552 4.96818 10.4552 4.85063 10.3219 4.82824L4.21634 3.89904C4.19968 3.89344 4.18301 3.89344 4.16634 3.89344C4.09968 3.89344 4.03857 3.91583 3.98856 3.96061C3.9219 4.01659 3.88856 4.08936 3.88856 4.17332V15.8274C3.88856 15.9842 4.01634 16.1073 4.16634 16.1073H5.55524V16.3872C5.55524 16.5439 5.67746 16.6671 5.83301 16.6671H4.16634C3.70523 16.6671 3.33301 16.292 3.33301 15.8274V4.17332C3.33301 3.92703 3.43856 3.69193 3.62745 3.5352C3.81634 3.37287 4.06079 3.3057 4.30523 3.34488Z"
        fill={color}
      />
    </svg>
  )
}

export default BuildingIcon
